import styled from 'styled-components';

export const TagContainer = styled.div`
  padding: 20px;
`;
